"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FRENCH_DOM_TOM_COUNTRIES_CODES = void 0;
exports.FRENCH_DOM_TOM_COUNTRIES_CODES = [
    'BL',
    'GF',
    'GP',
    'MC',
    'MF',
    'MQ',
    'NC',
    'PF',
    'PM',
    'RE',
    'TF',
    'WF',
    'YT',
];
